import { $Qll } from '../utils/query-selector'
import Swiper from 'swiper'
import { Navigation, Pagination, FreeMode, Autoplay, Thumbs } from 'swiper/modules'

const configArrows = (id) => {
  new Swiper(id, {
    modules: [ Navigation, FreeMode ],
    slidesPerView: 1,
    spaceBetween: 25,
    pagination: true,
    navigation: {
      nextEl: `.swiper-button-next[data-id="${id.substr(1)}"]`,
      prevEl: `.swiper-button-prev[data-id="${id.substr(1)}"]`,
    },
    freeMode: true,
    breakpoints: {
      749: {
        slidesPerView: 1,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
}

export const configPagination = (id) => {
  new Swiper(id, {
    modules: [Pagination, FreeMode, Thumbs],
    slidesPerView: 1,
    spaceBetween: 25,
    pagination: {
      el: `.swiper-pagination[data-id="${id.substr(1)}"]`,
      clickable: true
    },
    freeMode: true,
    pagination: true,

    breakpoints: {
      749: {
        slidesPerView: 1,
        spaceBetween: 28,
        freeMode: false,
      },
    },
  });
}

export const configSwiperUpsell = {
  modules: [Pagination],
  slidesPerView: 1,
  spaceBetween: 28,
  cssMode: true,
  paginationClickable: true,
  pagination: {
    el: '#slider_upsell-pagination',
    clickable: true
  },
  breakpoints: {
    749: {
      slidesPerView: 1,
      spaceBetween: 28,
      pagination: {
        el: '#slider_upsell-pagination',
        clickable: true
      },
    },
    1024: {
      cssMode: false
    }
  },
}

export const swiperSmall = new Swiper(".slider_small", {
  modules: [Pagination, Autoplay],
  slidesPerView: 1,
  spaceBetween: 25,
  paginationClickable: true,
  pagination: {
    el: ".swiper-pagination",
  },
  freeMode: true,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
});

export const swiperArrows = (() => {
  $Qll(".slider_arrows").map(slide => {
    configArrows('#' + slide.id)
  })
})();

export const swiperPagination = (() => {
  $Qll(".slider_pagination").map(slide => {
    configPagination('#' + slide.id)
  })
})();

export const sliderUpsell = () => {
  new Swiper('.slider_upsell', configSwiperUpsell);
};


export const specialSwiper = new Swiper('.jc-special-products-swiper', {
  slidesPerView: "auto",
  spaceBetween: 16,
});


export const rewardsSwiper = new Swiper('.jc-rewards-swiper', {
  slidesPerView: "auto",
  spaceBetween: 16,
});

export const quotesSwiper = new Swiper('.jc-quotes-slider', {
  modules: [Pagination, Autoplay],
  slidesPerView: 1,
  spaceBetween: 25,
  paginationClickable: true,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  freeMode: true,
  autoplay: {
    delay: 5500,
    disableOnInteraction: false,
  },
});